import { AppError } from "config/errors";
import { fetchPendingPolicy } from "gql/queries/pendingPolicy";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */

export const getPendingPolicy = createAsyncThunk(
  "policy/getPendingPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchPendingPolicy();
      const account = getActiveAccount(data.me);

      return account?.pendingPolicy;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
